"use client";

import { forwardRef, type ReactPortal, type Ref, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

type ClientOnlyPortalProps = {
  children: React.ReactNode;
  selector: string;
};

function ClientOnlyPortal(
  { children, selector }: ClientOnlyPortalProps,
  outerRef?: Ref<HTMLDivElement>,
): ReactPortal | null {
  const ref = useRef<Element>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    ref.current = document.querySelector(selector) as Element;
    setMounted(true);
  }, [selector]);

  return mounted ? createPortal(<div ref={outerRef}>{children}</div>, ref.current as Element) : null;
}

const forwardClientOnlyPortal = forwardRef(ClientOnlyPortal);
forwardClientOnlyPortal.displayName = "ClientOnlyPortal";
export default forwardClientOnlyPortal;
